import { useContext, useEffect } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import { useNavigate } from "react-router-dom";

const RedirectTenantHome = () => {
  const navigate = useNavigate();
  const { setLoading } = useContext(AuthContext);
  useEffect(() => {
    setLoading(true);
    navigate("/home");
  }, []);

  return <></>;
};

export default RedirectTenantHome;
